import { Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useDialog } from "lib/@hooks/useDialog"
import Iconify from "minimals-template/components/Iconify"
import { ComponentLibraryPickerDialog } from "authoring/routes/project/group/overwrite/task-correlator/component-library-picker-dialog"
import { navigateComponentSimilarity } from "authoring/routes/project/utilities/project-navigation"
import { useParams } from "react-router"

export function FindTasks({ variant = "outlined" }) {
    const { project, projectGroup } = useBoundContext()
    const { projectId, groupId } = useParams()
    const hasTasks = Boolean(projectGroup?.sourceTask) || projectGroup?.similarTasks?.length > 0
    const openComponentPicker = useDialog(<ComponentLibraryPickerDialog />, { maxWidth: "lg", fullWidth: true })
    return (
        <Button
            variant={variant}
            startIcon={<Iconify icon="lucide:text-search" />}
            onClick={handleOpenPicker}
            data-cy="project-find-tasks-button"
            disabled={hasTasks || projectGroup?.readOnly}
        >
            Find Tasks
        </Button>
    )

    async function handleOpenPicker() {
        const picked = await openComponentPicker()
        if (!picked?.componentId) return

        navigateComponentSimilarity({
            projectId: project?.id ?? projectId,
            groupId: projectGroup?.id ?? groupId,
            componentId: picked.componentId,
            componentVersion: picked.componentVersion ?? 1,
        })
    }
}
